import { UseFormReturn } from 'react-hook-form';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import {
  useDrawingContext,
  useDrawingLifecycle,
  useResetDrawingContext,
} from './DrawingContext';
import { DrawGeometryType } from '../isDrawGeometryType';
import { createGeometryFromGeoJson } from '@ais-ui/utils';
import { DrawingStyles } from '../styles/getDrawingStyle';
import { propagateGeometryChanges } from '../propagateGeometryChanges';

export const useDrawFromDialog = (
  form: UseFormReturn<any>,
  setShowDialog: (showDialog: boolean) => void,
  geometryField = 'geometry',
  drawingStyle?: DrawingStyles
) => {
  const { onStartDrawing, onFinishDrawing } = useDrawingLifecycle();
  const resetDrawingContext = useResetDrawingContext();
  const { setShowDrawPanel, onFinish, onCancel } = useDrawingContext();
  const onFinishDrawingFromDialog = () => {
    const geojson = onFinishDrawing();
    if (!geojson) return;

    const geometry = createGeometryFromGeoJson(geojson);

    propagateGeometryChanges(geometry, geometryField, form);

    resetDrawingContext();
    onFinish.current = null;
    onCancel.current = null;
    setShowDrawPanel(false);
    setShowDialog(true);
  };

  const onCancelDrawingFromDialog = () => {
    resetDrawingContext();
    onFinish.current = null;
    onCancel.current = null;
    setShowDialog(true);
  };

  const onStartDrawingFromDialog = (
    geometryType: DrawGeometryType,
    shape: GeoJson | undefined | null,
    maxPoints?: number
  ) => {
    onFinish.current = onFinishDrawingFromDialog;
    onCancel.current = onCancelDrawingFromDialog;
    onStartDrawing(geometryType, shape, true, drawingStyle, maxPoints);
    setShowDialog(false);
  };

  return {
    onFinishDrawingFromDialog,
    onStartDrawingFromDialog,
    onCancelDrawingFromDialog,
  };
};
